import { IsNotEmpty } from "class-validator";

export class EnvLanguageDto {
  @IsNotEmpty()
  language: string;
}
